import ReactGA from 'react-ga4';
import { sendAmplitudeData, sendAmplitudeRevenue, setAmplitudeUserId } from './amplitude';
import { sendLockerStudioData } from './lockerStudio';
import BI_EVENTS from './biEvents';
import { PLANS } from './eCommerce';
import { REACT_APP_GOOGLE_TRACKING_ID, REACT_APP_GOOGLE_ADS_ID } from './GA';


const isStage = process.env.REACT_APP_ENV === 'stage';

export const sendAnalyticsEvents = (eventName, eventParams = {}) => {
    const biEventName = BI_EVENTS[eventName];

    sendAmplitudeData(eventName, eventParams);
    sendLockerStudioData(biEventName || eventName, eventParams);
    pushGoogleTag(eventName, eventParams);
};

export const sendRevenueEvent = plan => {
    let eventParams = PLANS[plan];
    sendAmplitudeRevenue(eventParams);
};

export const setAnalyticsUserId = (userId = '') => {
    setAmplitudeUserId(userId);
};

export const pushGoogleTag = (eventName, eventParams, tagId = REACT_APP_GOOGLE_TRACKING_ID) => {
    if (isStage) return;
    ReactGA.event(eventName, { ...eventParams, send_to: tagId });
};

export const pushFBEvent = (data, eventId) => {
    if (window.fbq) {
        window.fbq('track', 'Purchase'+(isStage ? '_test' : ''), data, {eventID: eventId});
    }
};

export const sendPurchaseEvent = (
  price,
  currency,
  plan,
  sub_id,
  event_id,
  gclid = ''
) => {
    pushFBEvent(
      {
          currency: currency || 'USD',
          itemCount: 1,
          transactionId: sub_id,
          price: price,
          value: price,
      },
      event_id
    );
    pushGoogleTag(
      'purchase',
      {
        currency: currency || 'USD',
        value: price,
        transaction_id: sub_id,
        gclid,
        items: {
          item_id: plan,
          item_name: plan,
        },
      }
    );
    pushGoogleTag(
      "conversion",
      {
          value: price,
          currency: currency || "USD",
          transaction_id: sub_id,
      },
      REACT_APP_GOOGLE_ADS_ID
    );
};
